import * as React from 'react'
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle'
import PeopleIcon from '@mui/icons-material/People'
import GroupWorkIcon from '@mui/icons-material/GroupWork'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import { Link } from 'gatsby'
import styled from 'styled-components'

const LinksContainer = styled.div`
  a {
    color: black;
    text-decoration: none;
  }
`

export const productAdminItems = (
  <LinksContainer>
    <ListSubheader inset>Product</ListSubheader>
    <Link to="/organizations">
      <ListItem button>
        <ListItemIcon>
          <GroupWorkIcon />
        </ListItemIcon>
        <ListItemText primary="Organizations" />
      </ListItem>
    </Link>

    <Link to={encodeURI('/organizationAdmins?page=1&limit=10')}>
      <ListItem button>
        <ListItemIcon>
          <SupervisedUserCircleIcon />
        </ListItemIcon>
        <ListItemText primary="Organization admins" />
      </ListItem>
    </Link>
  </LinksContainer>
)

export const organizationAdminItems = (
  <LinksContainer>
    <ListSubheader inset>Organization</ListSubheader>
    <Link to="/patients">
      <ListItem button>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Patients" />
      </ListItem>
    </Link>
  </LinksContainer>
)
